import React, { useState, useEffect, useMemo } from 'react';

// LoadPanel
import { LoadPanel } from 'devextreme-react/load-panel';

// Toast
import { Toast } from 'devextreme-react/toast';

//Form
import Form, { Item, GroupItem, Label, TabbedItem, TabPanelOptions, Tab } from 'devextreme-react/form';

import { get, post } from 'aws-amplify/api';

// Ruteador
import { Link, useHistory } from "react-router-dom";

import { getCurrentUser } from 'aws-amplify/auth';

// Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRotateLeft } from "@fortawesome/pro-solid-svg-icons";
import { faSave } from "@fortawesome/pro-solid-svg-icons";
import { faUser } from "@fortawesome/pro-duotone-svg-icons";
import { faTrashAlt } from "@fortawesome/pro-solid-svg-icons";

import { callProcesa } from '../api/callProcesa';

import './Users.css';

export default function UsersForm(props) {
  const history = useHistory();

  const userName = props.userName;

  const [employees, setEmployees] = useState([]);

  const [userPayload, setUserPayload] = useState({
  });

  const [visibleLoadPanel, setVisibleLoadPanel] = useState(false);

  const [visibleToast, setVisibleToast] = useState(false);
  const [messageToast, setMessageToast] = useState('');
  const [typeToast, setTypeToast] = useState('success');

  const getEmployeeList = React.useCallback(async () => {
    var datos = await callProcesa('/procesahelper', {
      action: 'employeeList'
    });

    setEmployees(datos.data);

  }, []);

  const getUserPayload = React.useCallback(async (Username, internalid) => {
    var user = {};

    try {
      // Obtenemos los usuarios de Cognito
      let apiNameCognito = 'AdminQueries';
      let pathCognito = '/getUser';
      var userDetails = await getCurrentUser();

      let myInitCognito = {
        headers: {
          'Content-Type': 'application/json',
        },
        queryParams: {
          username: Username,
          q: window.btoa(userDetails.username)
        }
      }

      var response = await get({
        apiName: apiNameCognito,
        path: pathCognito,
        options: myInitCognito
      }).response;

      var userGetCognito = await response.body.json();

      user = {
        Username: userGetCognito.Username,
        Enabled: userGetCognito.Enabled,
        isAdmin: ''
      };

      // Obtenemos los atributos de los usuarios desde Netsuite
      var userAttributes = await callProcesa('/procesausuario', {
        action: 'payload',
        userName: Username,
        internalid: internalid
      });

      user.internalid = userAttributes.data.internalid;

      // Asignamos los atributos
      if (!userAttributes.data.custrecord_al_portal_employee)
        user.custrecord_al_portal_employee = ''
      else
        user.custrecord_al_portal_employee = userAttributes.data.custrecord_al_portal_employee;

      if (!userAttributes.data.cluster)
        user.cluster = false
      else
        user.cluster = userAttributes.data.cluster;

      user.clusterLevel = userAttributes.data.clusterLevel;

      if (!userAttributes.data.location)
        user.location = false
      else
        user.location = userAttributes.data.location;

      user.locationLevel = userAttributes.data.locationLevel;

      if (!userAttributes.data.clusterType)
        user.clusterType = false
      else
        user.clusterType = userAttributes.data.clusterType;

      user.clusterTypeLevel = userAttributes.data.clusterTypeLevel;

      if (!userAttributes.data.productCluster)
        user.productCluster = false
      else
        user.productCluster = userAttributes.data.productCluster;

      user.productClusterLevel = userAttributes.data.productClusterLevel;

      if (user.Enabled)
        user.Enabled = 'Activo'
      else
        user.Enabled = 'Inactivo'

      for (var attributeIndex in userGetCognito.UserAttributes) {
        var singleAttribute = userGetCognito.UserAttributes[attributeIndex];

        if (singleAttribute.Name === 'email')
          user.Email = singleAttribute.Value;
      }

      let apiNameGroups = 'AdminQueries';
      let pathGroups = '/listGroupsForUser';

      let myInitGroups = {
        headers: {
          'Content-Type': 'application/json',
        },
        queryParams: {
          username: Username,
          q: window.btoa(userDetails.username)
        }
      }

      const responseGroup = await get({
        apiName: apiNameGroups,
        path: pathGroups,
        options: myInitGroups
      }).response;

      var userGroupsGet = await responseGroup.body.json();

      for (var groupIndex in userGroupsGet.Groups) {
        var singleGroup = userGroupsGet.Groups[groupIndex];

        user.isAdmin = singleGroup.GroupName;
      }
    }
    catch (e) {
      if (e === 'No current user') {
        history.push('/');

        window.location.reload();
      }
    }

    return user;
  }, [history]);

  const deleteUser = React.useCallback(async () => {
    try {
      var username = userPayload.Username;

      if (username) {
        var r = window.confirm('Se eliminará el usuario ' + username + '. ¿Desea Continuar?');

        if (r) {
          let apiNameCognito = 'AdminQueries';
          let pathCognito = '/deleteUser';

          var userDetails = await getCurrentUser();

          let optionsCognito = {
            headers: {
              'Content-Type': 'application/json',
            },
            body: {
              username: username,
              q: window.btoa(userDetails.username)
            }
          }

          try {
            setVisibleLoadPanel(true);

            var response = await post({
              apiName: apiNameCognito,
              path: pathCognito,
              options: optionsCognito
            }).response;

            var datos = await response.body.json();

            setVisibleToast(true);
            setMessageToast('Usuario eliminado con éxito');
            setTypeToast('success')

            setVisibleLoadPanel(false);

            history.push('/Users');

          }
          catch (error) {
            setVisibleLoadPanel(false);

            setVisibleToast(true);
            setMessageToast(error.message);
            setTypeToast('error')
          }
        }
      }
    }
    catch (e) {
      if (e === 'No current user') {
        history.push('/');

        window.location.reload();
      }
    }
  }, [history, userPayload.Username]);

  const saveButton = React.useCallback(async () => {
    try {
      var username = userPayload.Username;
      var internalid = userPayload.internalid;
      var password = userPayload.Password;
      var confirmpassword = userPayload.ConfirmPassword;
      var group = userPayload.isAdmin;
      var sucursal = userPayload.Sucursal;
      var empleado = userPayload.custrecord_al_portal_employee;
      var email = userPayload.Email;
      var isenabled = userPayload.Enabled;

      if (username) {
        if (!password)
          password = '';
        if (!confirmpassword)
          confirmpassword = '';
        if (!group)
          group = '';

        if (!sucursal && sucursal !== 0)
          sucursal = '';

        if (password) {
          if (password.length < 8) {
            setVisibleToast(true);
            setMessageToast('La contraseña debe tener mínimo 10 caracteres');
            setTypeToast('error')
            return;
          }
          if (password !== confirmpassword) {
            setVisibleToast(true);
            setMessageToast('Las contraseñas no coinciden');
            setTypeToast('error')
            return;
          }
        }

        // Actualizamos los datos en Cognito
        let apiNameCognito = 'AdminQueries';
        let pathCognito = '/updateUser';

        let optionsCognito = {
          headers: {
            'Content-Type': 'application/json',
          },
          body: {
            email: email,
            username: username,
            password: password,
            confirmpassword: confirmpassword,
            isenabled: isenabled,
            group: group,
            custrecord_al_portal_employee: empleado
          }
        }

        try {
          setVisibleLoadPanel(true);

          var responseCognito = await post({
            apiName: apiNameCognito,
            path: pathCognito,
            options: optionsCognito
          }).response;

          // Actualizamos los datos en Netsuite
          await callProcesa('/procesausuario', {
            userName: username,
            internalid: internalid,
            action: 'postData',
            data: userPayload
          });

          setVisibleLoadPanel(false);

          setVisibleToast(true);
          setMessageToast('Usuario actualizado con éxito');
          setTypeToast('success')
        }
        catch (error) {
          setVisibleLoadPanel(false);

          setVisibleToast(true);
          setMessageToast(error.message);
          setTypeToast('error')
        }
      }
    }
    catch (e) {
      if (e === 'No current user') {
        history.push('/');

        window.location.reload();
      }
    }
  }, [history, userPayload]);

  const onFieldDataChanged = React.useCallback((e) => {
  }, []);

  var internalidEditorOptions = useMemo(() => {
    return { width: '100%', readOnly: true, visible: false };
  }, []);

  var userNameEditorOptions = useMemo(() => {
    return { width: '100%', readOnly: true };
  }, []);

  var emailEditorOptions = useMemo(() => {
    return { width: '100%', readOnly: true };
  }, []);

  var passwordEditorOptions = useMemo(() => {
    return { width: '100%', disabled: false, mode: 'password' };
  }, []);

  //Opciones Grupo del Usuario
  const isAdminOptions = useMemo(() => {
    return [
      { value: '', name: '' },
      { value: 'Admin', name: 'Admin' }
    ];
  }, []);

  try {
    var isAdminEditorOptions = useMemo(() => {
      return {
        items: isAdminOptions,
        displayExpr: 'name',
        valueExpr: 'value',
        searchEnabled: true,
        value: (userPayload.isAdmin ? userPayload.isAdmin : ''), width: '100%'
      };
    }, [isAdminOptions, userPayload.isAdmin]);
  }
  catch (e) {
    var isAdminEditorOptions = {
      items: isAdminOptions,
      displayExpr: 'name',
      valueExpr: 'value',
      searchEnabled: true,
      value: '',
      width: '100%'
    };
  }

  //Opciones Estatus del Usuario
  const enabledOptions = useMemo(() => {
    return [
      { value: 'Activo', name: 'Activo' },
      { value: 'Inactivo', name: 'Inactivo' }
    ];
  }, []);

  try {
    var enabledEditorOptions = useMemo(() => {
      return {
        items: enabledOptions,
        displayExpr: 'name',
        valueExpr: 'value',
        searchEnabled: true,
        value: (userPayload.Enabled ? userPayload.Enabled : ''), width: '100%'
      };
    }, [enabledOptions, userPayload.Enabled]);
  }
  catch (e) {
    var enabledEditorOptions = {
      items: enabledOptions,
      displayExpr: 'name',
      valueExpr: 'value',
      searchEnabled: true,
      value: '',
      width: '100%'
    };
  }

  //Opciones Nivel de Permiso
  const levelOptions = useMemo(() => {
    return [
      { value: 'Ver', name: 'Ver' },
      { value: 'Editar', name: 'Editar' }
    ];
  }, []);

  //Opciones Nivel de Permiso Product Cluster
  const productClusterlevelOptions = useMemo(() => {
    return [
      { value: 'Ver', name: 'Ver' },
      { value: 'Editar', name: 'Editar' },
      { value: 'Procesar', name: 'Procesar' }
    ];
  }, []);

  try {
    var clusterLevelEditorOptions = useMemo(() => {
      return {
        items: levelOptions,
        displayExpr: 'name',
        valueExpr: 'value',
        searchEnabled: false,
        value: (userPayload.clusterLevel ? userPayload.clusterLevel : ''), width: '50%', disabled: false
      };
    }, [levelOptions, userPayload.clusterLevel]);

  }
  catch (e) {
    var clusterLevelEditorOptions = {
      items: levelOptions,
      displayExpr: 'name',
      valueExpr: 'value',
      searchEnabled: false,
      value: '',
      width: '50%'
    };
  }

  try {
    var employeeEditorOptions = useMemo(() => {
      return {
        items: employees,
        displayExpr: 'name',
        valueExpr: 'value',
        searchEnabled: true,
        value: (userPayload.custrecord_al_portal_employee ? userPayload.custrecord_al_portal_employee : ''),
        width: '100%',
        disabled: false
      };
    }, [employees, userPayload.custrecord_al_portal_employee]);

  }
  catch (e) {
    var employeeEditorOptions = {
      items: employees,
      displayExpr: 'name',
      valueExpr: 'value',
      searchEnabled: true,
      value: '',
      width: '100%'
    };
  }


  try {
    var locationLevelEditorOptions = useMemo(() => {
      return {
        items: levelOptions,
        displayExpr: 'name',
        valueExpr: 'value',
        searchEnabled: false,
        value: (userPayload.locationLevel ? userPayload.locationLevel : ''), width: '50%', disabled: false
      };
    }, [levelOptions, userPayload.locationLevel]);
  } catch (error) {
    var locationLevelEditorOptions = {
      items: levelOptions,
      displayExpr: 'name',
      valueExpr: 'value',
      searchEnabled: false,
      value: '',
      width: '50%'
    };
  }

  try {
    var clusterTypeLevelEditorOptions = useMemo(() => {
      return {
        items: levelOptions,
        displayExpr: 'name',
        valueExpr: 'value',
        searchEnabled: false,
        value: (userPayload.clusterTypeLevel ? userPayload.clusterTypeLevel : ''), width: '50%', disabled: false
      };
    }, [levelOptions, userPayload.clusterTypeLevel]);
  } catch (error) {
    var clusterTypeLevelEditorOptions = {
      items: levelOptions,
      displayExpr: 'name',
      valueExpr: 'value',
      searchEnabled: false,
      value: '',
      width: '50%'
    };
  }


  try {
    var productClusterLevelEditorOptions = useMemo(() => {
      return {
        items: productClusterlevelOptions,
        displayExpr: 'name',
        valueExpr: 'value',
        searchEnabled: false,
        value: (userPayload.productClusterLevel ? userPayload.productClusterLevel : ''), width: '50%', disabled: false
      };
    }, [productClusterlevelOptions, userPayload.productClusterLevel]);
  } catch (error) {
    var productClusterLevelEditorOptions = {
      items: productClusterlevelOptions,
      displayExpr: 'name',
      valueExpr: 'value',
      searchEnabled: false,
      value: '',
      width: '50%'
    };
  }
  var toastPosition = useMemo(() => {
    return {
      my: 'top center',
      at: 'top center',
      of: window,
      offset: '0 130'
    }
  }, []);

  useEffect(() => {
    async function initialize() {
      setVisibleLoadPanel(true);

      await getEmployeeList();

      var payload = await getUserPayload(userName);

      setUserPayload(payload);

      setVisibleLoadPanel(false);
    }

    initialize();

    // eslint-disable-next-line
  }, []);

  const onHidingToast = React.useCallback(() => {
    setVisibleToast(false);
  }, []);

  return (
    <div>
      <div class="bg-gray-200 m-2">
        <h1 class="font-sans inline-block text-xl font-bold text-gray-700 leading-8 align-top mb-1 pl-3"><FontAwesomeIcon icon={faUser} size="xl" /> {userPayload.Username}</h1>
      </div>

      <LoadPanel
        shadingColor="rgba(0,0,0,0.4)"
        visible={visibleLoadPanel}
        showIndicator={true}
        message="Por favor espere..."
        shading={true}
        showPane={true}
        hideOnOutsideClick={false}
      />

      <Toast
        visible={visibleToast}
        message={messageToast}
        type={typeToast}
        onHiding={onHidingToast}
        displayTime={5000}
        width={'auto'}
        position={toastPosition}
      />

      <div class="m-3 bg-gray-200">
        <Link to="/Users">
          <button type="submit" class="mb-4 bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded">
            <FontAwesomeIcon icon={faArrowRotateLeft} /> Regresar
          </button>
        </Link>

        <button onClick={saveButton} type="submit" class="ml-4 mb-4 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
          <FontAwesomeIcon icon={faSave} /> Guardar Cambios
        </button>

        <button onClick={deleteUser} type="submit" class="ml-4 mb-4 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
          <FontAwesomeIcon icon={faTrashAlt} /> Eliminar Usuario
        </button>

        <div class="mt-1 bg-white pt-3 shadow-xl">
          <div class="ml-4 mr-4 bg-white pt-3">
            <Form
              id="datosGenerales"
              labelMode={'outside'}
              formData={userPayload}

              showColonAfterLabel={false}
              labelLocation={'left'}
              colCount={2}
              onFieldDataChanged={onFieldDataChanged}
            >
              <GroupItem caption="Datos Generales">
                <Item cssClass="boldText" dataField="internalid" editorOptions={internalidEditorOptions} >
                  <Label text="" visible={false} />
                </Item>
                <Item cssClass="boldText" dataField="Username" editorOptions={userNameEditorOptions} />
                <Item cssClass="boldText" dataField="Email" editorOptions={emailEditorOptions} />
                <Item dataField="Enabled" editorType="dxSelectBox" editorOptions={enabledEditorOptions} >
                  <Label text="Estatus" />
                </Item>
                <Item dataField="isAdmin" editorType="dxSelectBox" editorOptions={isAdminEditorOptions} >
                  <Label text="Grupo" />
                </Item>
                <Item dataField="custrecord_al_portal_employee" editorType="dxSelectBox" editorOptions={employeeEditorOptions}>
                  <Label text="Empleado Netsuite" />
                </Item>
              </GroupItem>
              <GroupItem caption="Contraseña">
                <Item dataField="Password" editorOptions={passwordEditorOptions} >
                  <Label text="Contraseña" />
                </Item>
                <Item dataField="ConfirmPassword" editorOptions={passwordEditorOptions} >
                  <Label text="Confirmar Contraseña" />
                </Item>
              </GroupItem>
              <GroupItem caption="Accesos" colSpan={2}>
              </GroupItem>
              <GroupItem caption="Clusters">
                <TabbedItem>
                  <TabPanelOptions deferRendering={false} showNavButtons={true} />
                  <Tab title="Cluster Types">
                    <Item dataField="clusterType" editorType="dxCheckBox">
                      <Label text="Cluster Types" />
                    </Item>
                    <Item dataField="clusterTypeLevel" editorType="dxSelectBox" editorOptions={clusterTypeLevelEditorOptions} >
                      <Label text="Nivel Permiso" />
                    </Item>
                  </Tab>
                  <Tab title="Clusters">
                    <Item dataField="cluster" editorType="dxCheckBox">
                      <Label text="Clusters" />
                    </Item>
                    <Item dataField="clusterLevel" editorType="dxSelectBox" editorOptions={clusterLevelEditorOptions} >
                      <Label text="Nivel Permiso" />
                    </Item>
                  </Tab>
                  <Tab title="Locations">
                    <Item dataField="location" editorType="dxCheckBox">
                      <Label text="Locations" />
                    </Item>
                    <Item dataField="locationLevel" editorType="dxSelectBox" editorOptions={locationLevelEditorOptions} >
                      <Label text="Nivel Permiso" />
                    </Item>
                  </Tab>
                  <Tab title="Product-Clusters">
                    <Item dataField="productCluster" editorType="dxCheckBox">
                      <Label text="Product Clusters" />
                    </Item>
                    <Item dataField="productClusterLevel" editorType="dxSelectBox" editorOptions={productClusterLevelEditorOptions} >
                      <Label text="Nivel Permiso" />
                    </Item>
                  </Tab>
                </TabbedItem>
              </GroupItem>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}
